import React from 'react';
import { Section, Reveal } from './Section';
const rows = [{
  action: 'Meses investigando sin animarte',
  cost: 'Tiempo perdido, cero avance real'
}, {
  action: 'Operar sin gestión de riesgo',
  cost: 'Capital expuesto desde la primera operación'
}, {
  action: 'Estrategias sin backtesting',
  cost: 'Pérdidas evitables por falta de validación'
}, {
  action: 'Esperar juntar $500 USD',
  cost: 'El mundo de las inversiones sigue esperando'
}];
export function CostOfDelay() {
  return <Section className="border-y border-white/5 bg-ink-900" data-id="element-49" data-mp="28ten5kb6fw8t">
      <Reveal data-id="element-50" data-mp="28rlbtrpmcnuh">
        <h2 className="font-display text-2xl font-bold leading-tight tracking-tight text-white sm:text-3xl lg:text-4xl" data-id="element-51" data-mp="28rbn07gb8mqd">
          El costo de postergar
        </h2>
      </Reveal>

      <Reveal delay={0.08} data-id="element-52" data-mp="1yvs02ajq4ydr">
        <div className="mt-8 overflow-hidden rounded-2xl border border-white/10" data-id="element-53" data-mp="3p7xxzs199a0l">
          <div className="grid grid-cols-2 border-b border-white/10 bg-ink-850 text-xs font-semibold uppercase tracking-wide text-gray-400 sm:text-sm" data-id="element-54" data-mp="3p63emi5mtpym">
            <div className="p-3 sm:p-4" data-id="element-55" data-mp="1u2amj65t5p2a">Lo que hacés hoy</div>
            <div className="border-l border-white/10 p-3 sm:p-4" data-id="element-56" data-mp="1p4itu9xc9yx1">Lo que te cuesta</div>
          </div>
          {rows.map((r, i) => <div key={r.action} className={`grid grid-cols-2 text-sm ${i % 2 === 0 ? 'bg-ink-900' : 'bg-ink-950'}`} data-id="element-57" data-mp="23teyry43mvtf" data-mpi={i}>
              <div className="p-3 font-medium text-gray-200 sm:p-4" data-id="element-58" data-mp="1yvdhniq8h6kl">
                {r.action}
              </div>
              <div className="border-l border-white/10 p-3 text-gray-400 sm:p-4" data-id="element-59" data-mp="1b4zv27qf3zxe">
                {r.cost}
              </div>
            </div>)}
        </div>
      </Reveal>
    </Section>;
}